import React, { useState, useEffect } from "react";
import { Transition } from "semantic-ui-react";
import { developers, proyectLeader } from "../../data/equipoDesarrollo";
import "./DesarrolladoPor.scss";

export function DesarrolladoPor() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setVisible(true);
  }, []);

  return (
    <div className="acercade-page">
      <Transition animation="fade down" duration={800} visible={visible}>
        <div>
          <h2 className="tituloPage">🏗️ EQUIPO DE DESARROLLO</h2>
          <p className="descripcionPage">
            Esta <b>plataforma web</b> es el resultado del{" "}
            <b>trabajo colaborativo</b> entre{" "}
            <b>profesionales en informática</b>,{" "}
            <b>profesionales de la salud</b> y{" "}
            <b>especialistas de diversas disciplinas</b>.
          </p>
        </div>
      </Transition>
      <Transition animation="fade up" duration={800} visible={visible}>
        <div className="devpage-content-center">
          <h3 className="devpage-collab-title">🗂️ LIDER DE PROYECTO</h3>

          <div className="devpage-developers-list">
            {proyectLeader.map((dev, index) => (
              <div
                key={index}
                className="devpage-developer-card"
                style={{
                  borderLeft: `8px solid ${dev.color}`,
                }}
              >
                <h4>{dev.nombre}</h4>
                <p>{dev.descripcion}</p>
              </div>
            ))}
          </div>

          <h3 className="devpage-collab-title">🖥️ EQUIPO DE DESARROLLO WEB</h3>

          <div className="devpage-developers-list">
            {developers.map((dev, index) => (
              <div
                key={index}
                className="devpage-developer-card"
                style={{
                  borderLeft: `8px solid ${dev.color}`,
                }}
              >
                <h4>{dev.nombre}</h4>
                <p>{dev.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </Transition>
    </div>
  );
}
